<template >
  <div class="">
    <!-- <nav class="navbar navbar-light bg-light">
      <span class="navbar-brand mb-0 h1">Navbar</span>
    </nav> -->
    <div class="container mt-5">
      <div class="row">
        <div class="col">
          <!-- <button type="button" v-on:click="toggleFileModal" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-paperclip"></i></button> -->

          <div class="card">
            <div class="card-header">
              <div class="text-right">
                <button type="button" v-on:click="toggleFileModal" class="btn btn-dark"><i class="fa fa-upload"></i> Upload Report</button>
              </div>
            </div>
            <div class="card-body">
              <table class="table">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Year</th>
                    <th>Uploaded By</th>
                    <th>Comment</th>
                    <th>Files</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="reportEntryList.length">
                    <tr v-for="item in reportEntryList" :key="item.id">
                      <td>{{item.month}}</td>
                      <td>{{item.year}}</td>
                      <td>{{item.fullName}}</td>
                      <td>{{item.comment}}</td>
                      <td>
                        <div class="row col-12" v-for="(item,index) in item.fileList" :key="index">
                          <div class="col-8" style="overflow:hidden">
                            {{(item.name.length>=attachmentNameLengthLimit?item.name.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+item.name.split(".")[item.name.split(".").length-1]:item.name)}}
                          </div>
                          <div class="col-1">
                            <button  class="btn btn-light btn-sm" v-on:click="downloadFile(item.id)"><i class="fa fa-download"></i></button>
                          </div>
                          <br>
                          <br>
                        </div>

                        <!-- <button class="btn btn-dark" v-on:click="toggleDownloadModal(item.fileList)">
                          <i class="fa fa-download"></i>
                          <span> Download </span>
                          <template v-if="item.fileList.length">
                            <span class="badge badge-light"> {{item.fileList.length > 0 ? item.fileList.length : "" }}</span>
                          </template> -->
                          <!-- <badge type="white">{{item.fileList.length > 0 ? item.fileList.length : "" }}</badge> -->
                        <!-- </button> -->
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>


    <modal :show.sync="openNewFileModalFlag">
      <template slot="header">
        <h5 class="modal-title">Upload Files</h5>
      </template>

      <div class="row col-12">
        <div class="col-4">
          Date
        </div>
        <div class="col-8" >
          <input class="form-control" v-model="reportDate" type="date" required>
        </div>
      </div>
      <br>
      <div class="row col-12">
        <div class="col-4">
          Comment
        </div>
        <div class="col-8" >
          <textarea style="resize:none;" rows="2" class="form-control" v-model="comment" required></textarea>
        </div>
      </div>
      <br>
      <template v-if="displayNewFilesFlag">
        <div class="row col-12" v-for="(item,index) in reportAttachments" :key="index">
          <div class="col-1">
            <button type="button" v-on:click="removeFileFromList(index)" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-times"></i></button>
          </div>
          <div class="col-8" style="overflow:hidden">
            {{(item.name.length>=attachmentNameLengthLimit?item.name.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+item.name.split(".")[item.name.split(".").length-1]:item.name)}}
          </div>
          <!-- <br> -->
        </div>
      </template>
      <div class="row col-12">

        <div class="col-12">
          <!-- <span> Please choose a file to upload.</span> -->

          <br />
          <b-form-file
            id="commentAttachmentContainer"
            v-model="newFile"
            ref="fileToUpload"
            :state="null"
            placeholder="Choose a file..."
            @change="attachFile"
            :file-name-formatter="function(){return 'Choose a file...'}"
            multiple
          ></b-form-file>
          <br>
          <br>

          <div class="text-right">
            <button class="btn btn-info" v-on:click="saveReportEntry"><i class="fa fa-upload"></i> Upload Report</button>
          </div>
        </div>

      </div>
      <template slot="footer">
        <b-button type="secondary" @click="toggleFileModal">Close</b-button>
      </template>
    </modal>

    <modal :show.sync="openDownloadFileModalFlag">
      <template slot="header">
        <h5 class="modal-title">Download Files</h5>
      </template>
        <div class="row col-12" v-for="(item,index) in downloadFileList" :key="index">
          <!-- <div class="col-1">
            <button type="button" v-on:click="removeFileFromList(index)" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-times"></i></button>
          </div> -->
          <div class="col-8" style="overflow:hidden">
            {{(item.name.length>=attachmentNameLengthLimit?item.name.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+item.name.split(".")[item.name.split(".").length-1]:item.name)}}
          </div>
          <div class="col-1">
            <button  class="btn btn-light btn-sm" v-on:click="downloadFile(item.id)"><i class="fa fa-download"></i></button>
          </div>
          <br>
          <br>
        </div>
      <template slot="footer">
        <b-button type="secondary" @click="toggleDownloadModal">Close</b-button>
      </template>
    </modal>
  </div>
</template>

<script>
/* eslint-disable */
import { loadModules } from 'esri-loader';
import axios from "axios";
import modal from "@/components/Modal";
import {baseApiUrl} from "../../config.js";

export default {
  name: "LandingPage",
  components: {
    modal
  },
  data() {
    return {
      reportEntryList: {},
      openNewFileModalFlag: false,
      openDownloadFileModalFlag: false,
      downloadFileList: [],
      newFile: null,
      displayNewFilesFlag: false,
      attachmentNameLengthLimit: 25,
      fullName: "",
      arcGISUserName: "",
      comment: "",
      reportDate: "",
      reportAttachments: [],
      portalURL: "https://au1gis.solutions.arcadis.com/arcgis",
    }
  },
  mounted() {
    const current = this
    loadModules([
      "esri/config",
      "esri/identity/IdentityManager",
      "esri/identity/OAuthInfo",
      "esri/portal/Portal"
    ],
      { css: true })
    .then(([
      esriConfig,
      esriId,
      OAuthInfo,
      Portal
    ]) => {

      esriConfig.portalUrl = current.portalURL
      var authInfo = new OAuthInfo({
        appId: "J0AEIOwup4VWJ1jY",
        portalUrl: current.portalURL,
        popup: false
      });
      esriId.registerOAuthInfos([authInfo]);

      var portal = new Portal({
        url: current.portalURL
      });

      portal.authMode = "immediate";
      portal.load().then(function(portalResult) {
        console.log(portalResult);
        current.arcGISUserName = portalResult.user.username
        current.fullName = portalResult.user.fullName
      });

      esriId
        .checkSignInStatus(current.portalURL + "/sharing/rest")
        .then(function() {
            console.log("login success");
            current.fetchReportEntryList()
        })
        .catch(function(error) {
          console.log(error)
          esriId.getCredential(current.portalURL + "/sharing/rest");
        });
    });
  },
  methods: {
    toggleFileModal: function() {
      const current = this
      console.log(current.openNewFileModalFlag);
      current.openNewFileModalFlag = !current.openNewFileModalFlag
      console.log(current.openNewFileModalFlag);
    },
    toggleDownloadModal: function(fileList) {
      const current = this
      console.log(current.openDownloadFileModalFlag);
      current.openDownloadFileModalFlag = !current.openDownloadFileModalFlag
      if(current.openDownloadFileModalFlag){
        current.downloadFileList = fileList
      }

      console.log(current.openDownloadFileModalFlag);
    },
    fetchReportEntryList: function() {
      const current = this
      current.reportEntryList = {}
      let url = baseApiUrl + "fetchReportEntries"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result);
        current.reportEntryList = result.data
      })
    },
    saveReportEntry: function() {
      console.log("test");
      const current = this
      var attachmentsSuccessfulCount = 0
      return new Promise(function(resolve, reject) {
        let url = baseApiUrl + "saveReportEntry"
        let data = {
          fullName: current.fullName,
          arcGISUserName: current.arcGISUserName,
          comment: current.comment,
          reportDate: current.reportDate,
          // year: current.reportDate
        }
        let config = {
          responseType: 'json'
        }
        if (current.reportAttachments.length > 0) {
          axios.post(url, data, config)
          .then((result) => {
            console.log(result);
            if (current.reportAttachments.length > 0) {
              var fileURL = baseApiUrl + "fileUpload"
              current.reportAttachments.forEach(item => {
                  var fileData = new FormData();
                  fileData.append("fileinput"       , item);
                  fileData.append("reportEntryId"         , result.data.id);
                  fileData.append("filename"        , item.name);
                  fileData.append("filetype"        , item.type);
                  var fileConfig = {
                    headers: {
                      'content-type': 'application/octet-stream'
                    },
                    responseType: 'json'
                  }
                  axios.post(fileURL, fileData,   fileConfig).then(fileResult=>{
                    result.data.reportAttachments.push(fileResult.data)
                    attachmentsSuccessfulCount+=1
                    if (attachmentsSuccessfulCount==current.reportAttachments.length) {
                      current.fetchReportEntryList()
                      current.reportAttachments = []
                      current.openNewFileModalFlag = false
                      resolve(result.data)
                    }
                  })
                  .catch(error=>{
                    console.log(error);
                  })
              });
            }
            else {
              resolve(result.data)
            }

          })
        }
        else{
          reject()
        }
      })
    },
    attachFile: function(event) {
      const current = this
      current.displayNewFilesFlag = false
      var files = event.target.files
      files.forEach(item=>{
        current.reportAttachments.push(item)
      })
      current.displayNewFilesFlag = true
      current.newFile = null
    },
    removeFileFromList: function(index) {
      const current = this
      current.reportAttachments.splice(index,1)
    },
    downloadFile: function(fileId) {
      let formData = new FormData();
      let url = baseApiUrl + "downloadReport";
      let config = {
        headers: {
          'content-type': 'application/octet-stream'
        },
        responseType: 'blob'
      }
      formData.append("fileId", fileId);
      axios.post(url, formData, config).then((result) => {
        var disposition = result.headers['content-disposition'];
        // fix this matches
        var matches = /=(.*)/.exec(disposition);
        var filename = (matches != null && matches[1] ? matches[1] : '').replace(/"*/g,"");
        // filename = filename.replace(/"*/g,"");
        var type = result.headers['content-type'];
        var link = document.createElement('a');

        document.body.appendChild(link)
        link.style = "display: none"
        var blob = new Blob(
          [result.data],
          {type: result.headers['content-type']}
        );
        var url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        // link.remove();
      });
    },
  }
}
</script>

<style lang="css" scoped >

</style>
